import { useState } from 'react';
import { handleInputChange } from '../../utils/handleChange';
import Dropdown from '../dropdown/Dropdown';
import handleNestedChange from '../../utils/handleNestedChange';

export default function AddWebsiteBooking({ muBookData, setMuBookData }) {
    const [offerApplied, setOfferApplied] = useState(false);
    return (
        <>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Order Id</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.orderId}
                        name='orderId'
                        onChange={(e) => handleInputChange(e, setMuBookData)}
                        type='text'
                        placeholder={`Order Id`}
                        className='dropRegSelect'
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Payment Id</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.paymentId}
                        name='paymentId'
                        onChange={(e) => handleInputChange(e, setMuBookData)}
                        type='text'
                        placeholder={`Payment Id`}
                        className='dropRegSelect'
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Did they apply the offer?</label>
                <div className='dropRegInputDiv radioDiv'>
                    <label>
                        <input
                            type='radio'
                            name='offerApplied'
                            value='true'
                            checked={offerApplied === true}
                            onChange={() => setOfferApplied(true)}
                        />
                        Yes
                    </label>

                    <label>
                        <input
                            type='radio'
                            name='offerApplied'
                            value='false'
                            checked={offerApplied === false}
                            onChange={() => setOfferApplied(false)}
                        />
                        No
                    </label>
                </div>
            </div>
            {offerApplied && (
                <>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Offer Name</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={muBookData?.offerType?.name}
                                name='name'
                                onChange={(e) => handleNestedChange(e, setMuBookData, 'offerType')}
                                type='text'
                                placeholder={`Offer Name`}
                                className='dropRegSelect'
                            ></input>
                        </div>
                    </div>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Offer Code</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={muBookData?.offerType?.code}
                                name='code'
                                onChange={(e) => handleNestedChange(e, setMuBookData, 'offerType')}
                                type='text'
                                placeholder={`Offer Code`}
                                className='dropRegSelect'
                            ></input>
                        </div>
                    </div>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Offer Type</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={muBookData?.offerType?.type}
                                name='type'
                                onChange={(e) => handleNestedChange(e, setMuBookData, 'offerType')}
                                type='text'
                                placeholder={`Offer Type`}
                                className='dropRegSelect'
                            ></input>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
